<template>
  <el-empty :description="errorMsg"></el-empty>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'Error',
  data() {
    return {}
  },
  computed: {
    ...mapState('error', ['errorMsg'])
  }
}
</script>
